/**
 * @generated SignedSource<<8c08e319ec7cee90c480419e0a0ff41c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IntegrationIpoolShiftPartType = "BREAK" | "OTHER" | "WORK";
import { FragmentRefs } from "relay-runtime";
export type WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart$data = {
  readonly color: string | null;
  readonly description: string | null;
  readonly endAt: string;
  readonly startAt: string;
  readonly type: IntegrationIpoolShiftPartType;
  readonly " $fragmentType": "WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart";
};
export type WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart$key = {
  readonly " $data"?: WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "IntegrationIpoolShiftPart",
  "abstractKey": null
};

(node as any).hash = "eb2efb071d1af9c92e98d46cdc770219";

export default node;
